import {
  LIST_PROFILES_ERROR,
  LIST_PROFILES_START,
  LIST_PROFILES_SUCCESS,
} from 'constants/action-types/profiles/listProfiles';

export default (state, { type, payload }) => {
  switch (type) {
    case LIST_PROFILES_START:
      return {
        ...state,
        profileList: {
          ...state.profileList,
          loading: true,
          error: null,
        },
      };
    case LIST_PROFILES_ERROR:
      return {
        ...state,
        profileList: {
          ...state.profileList,
          error: payload,
          loading: false,
        },
      };
    case LIST_PROFILES_SUCCESS:
      return {
        ...state,
        profileList: {
          ...state.profileList,
          items: payload.data,
          meta: payload.meta,
          error: null,
          loading: false,
        },
      };
    default:
      return null;
  }
};
